import { render, staticRenderFns } from "./DrayageProvider.vue?vue&type=template&id=49eea9a6&scoped=true&"
import script from "./DrayageProvider.vue?vue&type=script&lang=js&"
export * from "./DrayageProvider.vue?vue&type=script&lang=js&"
import style0 from "./DrayageProvider.vue?vue&type=style&index=0&id=49eea9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eea9a6",
  null
  
)

export default component.exports